import { useTranslation } from 'react-i18next'

import { PROFILE_CONTACTS_WIDGET_QA_NAME } from '../ProfileContactsWidget.constants'
import { getContactQaName } from '../ProfileContactsWidget.utils'
import { ProfileContactsWidgetListCellButton } from '../ProfileContactsWidgetListCellButton'

import CopyIcon from '../../../../icons/copy.svg'
import EditIcon from '../../../../icons/edit.svg'

function ProfileContactsWidgetListCellViewButtons({
  canCopy = true,
  canEdit,
  className,
  isCopied,
  qaId,
  onCopy,
  onEdit,
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      {canCopy ? (
        <ProfileContactsWidgetListCellButton
          Icon={CopyIcon}
          disabled={isCopied}
          qaName={getContactQaName({
            id: qaId,
            qaName: PROFILE_CONTACTS_WIDGET_QA_NAME.copyButton,
          })}
          tooltip={
            isCopied
              ? t('ProfileContactsWidget.CopyingBtnKey')
              : t('ProfileContactsWidget.CopyBtnKey')
          }
          onClick={onCopy}
        />
      ) : null}
      {canEdit ? (
        <ProfileContactsWidgetListCellButton
          Icon={EditIcon}
          qaName={getContactQaName({
            id: qaId,
            qaName: PROFILE_CONTACTS_WIDGET_QA_NAME.editButton,
          })}
          tooltip={t('ProfileContactsWidget.EditBtnKey')}
          onClick={onEdit}
        />
      ) : null}
    </div>
  )
}

export default ProfileContactsWidgetListCellViewButtons
